import { useCallback, useRef } from "react";

export const useFlashcardTimer = () => {
  const startTimeRef = useRef<number>(Date.now());

  const resetTimer = useCallback(() => {
    startTimeRef.current = Date.now();
  }, []);

  const getElapsedSeconds = useCallback((): number => {
    return Math.floor((Date.now() - startTimeRef.current) / 1000);
  }, []);

  return { resetTimer, getElapsedSeconds };
};
